module.exports = {
    env: process.env.REACT_APP_DIST_ENV || 'beta',
    isDev: process.env.REACT_APP_DIST_ENV === 'local',
    isBeta: process.env.REACT_APP_DIST_ENV === 'beta',
    isProd: process.env.REACT_APP_DIST_ENV === 'prod',
    isMock: process.env.REACT_APP_MOCK === 'true'
}